const CARD_NUMBER = 'cardNumber';
const SECURITY_CODE = 'securityCode';

export {CARD_NUMBER, SECURITY_CODE};